//Comentario necesario para codificación en UTF-8, ver Inc6743
"use strict";

(function () {
	var App = angular.module('pphhApp');
	App.factory('HelpManagerService', ['$http', '$q', function ($http, $q)  {
		return {
	
			getTags : function () {
				var request = {
						method: "GET",
						url: _contextPath +"/helpManager/tags"
				};
	
				return $http(request);
			},
	
	//		getRestTags : function () {
	//			var request = {
	//					method: "GET",
	//					url: _contextPath +"/helpManager/getRestTags"
	//			};
	//
	//			return $http(request);
	//		},
	
			getHelps: function (nameHelp, descHelp, tags) {
				//alert('nameHelp '+nameHelp +' descHelp '+descHelp+' tags '+ tags);
				var request = {
						method: "GET",
						url: _contextPath +"/helpManager/resources",
						params: {
							nameHelp: nameHelp,
							descHelp: descHelp,
							tags : tags
						}
				};
				return $http(request);
			},
	
			uploadHelpFile: function(id, file, nameHelp, descHelp, enlace, tagsObject) {
	
				var deferred = $q.defer();
				var formData = new FormData();
	
				if(id != null) {
					formData.append("id", id);
				}
				if(file) {
					formData.append("file", file);
				}
				formData.append("nameHelp", nameHelp);
				formData.append("descHelp", descHelp);
				if(enlace) {
					formData.append("enlace", enlace);
				}
				formData.append("tagsObject", tagsObject);
	
				var request = {
						method: "POST",
						url: _contextPath + "/helpManager/resource",
						data: formData,
						transformRequest: angular.identity
					};
				request.headers = {};
				request.headers[_csrf_headerName] = _csrf_token;
				request.headers["Content-type"] = undefined;
	
				$http(request).then(
						function(res) {
							deferred.resolve(res.data);
						},
						function(msg, code) {
							deferred.reject(msg.data);
						});
				return deferred.promise;
			},
	
			getHelpDoc: function (id) {
			   	var request = {
			   		method: "GET",
			   		url: _contextPath +"/helpManager/resource/" + id
			   	};
			   	return $http(request);
			},
	
			createTag: function (tagName) {
		    	var request = {
					method: "POST",
					url: _contextPath + "/helpManager/tag",
					data: tagName
			    };
		    	request.headers = {};
		    	request.headers[_csrf_headerName] = _csrf_token;
		    	return $http(request);
		    },
	
		    updateTag: function (id, name) {
			   	var request = {
			   			method: "POST",
			   			url: "/helpManager/tag/" + id,
			   			data: name
			   	};
	
			   	return $http(request);
			},
	
			removeTag: function (id) {
		    	var request = {
		    			method: "DELETE",
		    			url: "/helpManager/tag/" + id,
				};
				
		    	return $http(request);
		    },
	
		    removeResource: function (id) {
		    	var request = {
		    			method: "DELETE",
		    			url: _contextPath + "/helpManager/resource/" + id,
	
				};
		    	request.headers = {};
		    	request.headers[_csrf_headerName] = _csrf_token;
		    	return $http(request);
		    }
		}
	}]);
})();
